import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
  DoCheck,
  DOCUMENT,
  inject
} from '@angular/core';
import { selectorCoreFormCurrentPageStatus } from '@bepatient/core';
import { IonItem } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import chroma from 'chroma-js';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TextQuestionV3 } from '../../../classes/question-text';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-text-v3',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  standalone: false
})
export class InputTextComponentV3
  extends QuestionBaseV3ComponentDirective
  implements AfterViewInit, OnDestroy, DoCheck
{
  document = inject(DOCUMENT);
  private translate = inject(TranslateService);
  private store$ = inject<Store<any>>(Store);

  _color: string;
  contrast: string;
  @Input() question: TextQuestionV3;

  placeholder: string;
  isBlur = true;
  hasError: boolean;
  subscription: Subscription;
  fieldErrors: Array<string>;
  dirty: boolean;

  @ViewChild(IonItem, { read: ElementRef, static: true }) ionItem: ElementRef;

  @Input()
  set color(c: string) {
    this._color = c;
    this.contrast =
      chroma(c || '#fafafa').luminance() < 0.6 ? '#fafafa' : '#2e2e2e';
  }
  get color() {
    return this._color;
  }

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngAfterViewInit(): void {
    this.ionItem.nativeElement.style.setProperty(
      '--input-valid-background',
      chroma(this.color).alpha(0.1).css()
    );
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onBlur(): void {
    this.isBlur = true;
    this.formGroup.get(this.question.key).markAsDirty();
  }

  onFocus(): void {
    this.isBlur = false;
  }

  onInput(): void {
    this.isBlur = false;
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onChange(): void {
    this.isBlur = false;
    this.dirty = this.formGroup.get(this.question.key).dirty;
    this.formGroup.get(this.question.key).markAsTouched();
  }

  checkValueIndicative() {
    if (
      !this.hasError &&
      this.value &&
      this.question &&
      ((this.question.minIndicative &&
        this.value < this.question.minIndicative) ||
        (this.question.maxIndicative &&
          this.value > this.question.maxIndicative))
    ) {
      this.question.infos = this.translate.instant('TEXT.RANGE_INDICATIVE');
    } else {
      this.question.infos = '';
    }
  }

  isEmpty(): boolean {
    return !this.value;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
